import type { Locale } from "./locale-utils";

// Перевод ЗНАЧЕНИЙ ТТХ авто (из 1С, по-русски) на английский для /en.
// Не найдено — возвращаем как есть (напр. новые/нестандартные значения).
const MAP: Record<string, string> = {
  // Коробка
  "акпп": "Automatic", "автомат": "Automatic", "автоматическая": "Automatic",
  "мкпп": "Manual", "механика": "Manual", "механическая": "Manual", "ручная": "Manual",
  "робот": "Robotic", "роботизированная": "Robotic", "amt": "Robotic",
  "вариатор": "CVT", "cvt": "CVT",
  // Топливо
  "бензин": "Petrol", "бензиновый": "Petrol",
  "дизель": "Diesel", "дизельный": "Diesel",
  "электро": "Electric", "электричество": "Electric", "электрический": "Electric",
  "гибрид": "Hybrid", "гибридный": "Hybrid",
  "газ": "Gas", "бензин/газ": "Petrol/Gas", "газ/бензин": "Gas/Petrol",
  // Привод
  "передний": "Front", "задний": "Rear", "полный": "AWD", "4wd": "4WD", "awd": "AWD",
  // Классы авто
  "промо": "Promo", "эконом": "Economy", "стандарт": "Standard", "комфорт": "Comfort",
  "кроссовер": "Crossover", "минивэн": "Minivan", "минивен": "Minivan", "бизнес": "Business",
  "внедорожник": "SUV", "кабриолет": "Convertible", "люкс": "Luxury", "премиум": "Premium",
  // Цвета
  "белый": "White", "чёрный": "Black", "черный": "Black", "серый": "Gray",
  "серебристый": "Silver", "серебряный": "Silver", "красный": "Red", "бордовый": "Maroon",
  "синий": "Blue", "голубой": "Light blue", "зелёный": "Green", "зеленый": "Green",
  "жёлтый": "Yellow", "желтый": "Yellow", "оранжевый": "Orange", "коричневый": "Brown",
  "бежевый": "Beige", "золотой": "Gold", "золотистый": "Gold", "фиолетовый": "Purple",
  "розовый": "Pink", "хамелеон": "Chameleon",
  // Классы (мн.число / из 1С)
  "кроссоверы": "Crossover", "минивены": "Minivan", "минивэны": "Minivan", "комфорт класс": "Comfort", "бизнес класс": "Business", "внедорожники": "SUV", "кабриолеты": "Convertible", "седаны": "Sedan", "седан": "Sedan", "универсал": "Wagon", "хэтчбек": "Hatchback",
  // Прочее
  "в сутки": "per day", "сутки": "day",
};

export function carSpecLabel(value: string | undefined, locale: Locale): string {
  const v = (value || "").trim();
  if (!v) return v;
  // Убираем суффикс « класс»/« класса» из названия класса («Комфорт класс» →
  // «Комфорт»): короче и влезает в плитку ТТХ 3×3 на мобиле.
  if (locale !== "en") return v.replace(/\s+класса?$/i, "").trim() || v;
  const mapped = MAP[v.toLowerCase()];
  if (mapped) return mapped;
  // «N мест / места / место» → «N seats»
  const m = v.match(/^(\d+)\s*(мест[оа]?|мест)$/i);
  if (m) return `${m[1]} seats`;
  // «N дверей / двери / дверь» → «N doors»
  const md = v.match(/^(\d+)\s*(двер[ьи]|дверей)$/i);
  if (md) return `${md[1]} doors`;
  // «N л» / «N л.» (объём двигателя) → «N L»
  const ml = v.match(/^([\d.,]+)\s*л\.?$/i);
  if (ml) return `${ml[1]} L`;
  // «N л/100км» (расход) → «N L/100km»
  const mc = v.match(/^([\d.,]+)\s*л\/100\s*км$/i);
  if (mc) return `${mc[1]} L/100km`;
  return v;
}
